export enum AppRole {
  Operator = 'Operator',
  Contractor = 'Contractor',
  ContractorEmployee = 'ContractorEmployee',
  Superuser = 'Superuser',
}
